import React from 'react';
import BannerPromo from '../BannerPromo';
import ListaParques from '../ListaParques';

const PaginaPrincipal = ({ pesquisa, pagina, setPagina, estaCarregado, setEstaCarregado, setParqueSelecionado }) => {
    return (
        <>
            {/* <BannerDengue /> */}
            {/* <BannerPromo /> */}

            <ListaParques 
                pesquisa={pesquisa} 
                estaCarregado={estaCarregado} 
                setEstaCarregado={setEstaCarregado}
                pagina={pagina} 
                setPagina={setPagina}
                setParqueSelecionado={setParqueSelecionado}
            />
        </>
    );
}

export default PaginaPrincipal;